'use client';

import { PrismicRichText } from '@prismicio/react';
import { Content } from '@prismicio/client';
import Table from './Table/Table';
import { useVisible } from '@/hooks';
import styles from './InnerContent.module.scss';
import { Simplify } from '../../../../prismicio-types';

interface Props {
  slice: Simplify<Content.AdvantagesOfHelocSliceDefaultPrimary>;
}

const InnerContent = ({ slice }: Props) => {
  const [isVisible, id] = useVisible();

  return (
    <div id={id} className={styles.wrapper}>
      <div className={`${styles.title} ${isVisible ? styles.isVisible : ''}`}>
        <PrismicRichText field={slice.title} />
      </div>
      <p className={`${styles.subtitle} ${isVisible ? styles.isVisible : ''}`}>
        {slice.subtitle}
      </p>
      <Table
        titles={slice.table_titles}
        data={slice.table_rows}
        isVisible={isVisible}
      />
    </div>
  );
};

export default InnerContent;
